import React from 'react';
import { default as ReactModal } from 'react-modal'
import Button from "../../common/Button";
import { Direct } from "./png-svg-icons/direct";
import { Indirect } from "./png-svg-icons/indirect";
import { Aquaefficiency } from "./png-svg-icons/aquaefficiency";

interface SelfProps {
    isOpen: boolean,
    onCloseClick: () => void
}

export default class ProductCatalogLegendModal extends React.Component<SelfProps> {
    modalStyle = {
        overlay: {
            zIndex: '1092',
            backgroundColor: 'rgba(148, 148, 148, 0.75)'
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '0',
            width: '650px'
        }
    }

    render() {
        return (
            <ReactModal isOpen={this.props.isOpen} style={this.modalStyle}
                onRequestClose={() => this.props.onCloseClick()}>
                <div className={'product-catalog-legend-modal modal'}>
                    <header className="modal-section">
                        <h3>{__("Card Legend")}</h3>
                    </header>
                    <main className="modal-section">
                        <div className={`legend`}>
                            <div className={`grid-2`}>
                                <div className={`legend-item`}>
                                    <div className={`title`}>
                                        <div className={`direct-icon`} />
                                        {__("Direct / Instantaneous")}
                                    </div>
                                    <Direct />
                                </div>
                                <div className={`legend-item`}>
                                    <div className={`title`}>
                                        <div className={`indirect-icon`} />
                                        {__("Indirect / Semi-instantaneous")}
                                    </div>
                                    <Indirect />
                                </div>
                            </div>
                            <div className={`separator`}>
                                {__("Application of Cetetherm aquaefficiency combined with heat pumps")}
                            </div>
                            <div className={`grid-2`}>
                                <div className={`legend-item`}>
                                    <Aquaefficiency />
                                </div>
                                <div className={`legend-item`}>
                                    <div className={`title`}>
                                        <div className={`plate-and-gaskets`} />
                                        {__("Plate & Gaskets heat exchanger")}
                                    </div>
                                    <div className={`title`}>
                                        <div className={`fusion-bonded`} />
                                        {__("Fusion-bonded heat exchanger")}
                                    </div>
                                    <div className={`title`}>
                                        <div className={`copper-brazed`} />
                                        {__("Copper Brazed heat exchanger")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <footer className="modal-section">
                        <Button onClick={this.props.onCloseClick}>{__('Close')}</Button>
                    </footer>
                </div>
            </ReactModal>
        )
    }
}